import React from 'react';

import './NotFound.css';

const NotFound = (props) => (
  <div className="NotFound">
    <h1 className="NotFound__title">Page not found</h1>
    <div className="NotFound__message">Page "{props.match.url}" does not exist!</div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/NotFound.js